<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"padding-bottom:200px;"' class="container " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   </template>
                </m-div><m-h1 v-bind='{...{},...{}}' :style='"border-radius:30px"' class="text-center shadow m-4 p-4" >
                <template #default>لیفت با نخ   </template>
                </m-h1><m-h4 v-bind='{...{},...{}}' :style='""' class="text-center m-5" >
                <template #default>لیفت صورت با نخ که به عنوان لیفت با نخ یا جوانسازی با نخ نیز شناخته می شود، یک روش غیر جراحی است که برای لیفت و سفت کردن پوست افتاده طراحی شده است. بر خلاف لیفت صورت سنتی که شامل برش ها و برداشتن پوست اضافی است، لیفت از نخ های قابل حل ساخته شده از مواد زیست سازگار استفاده می کند.
   </template>
                </m-h4><m-img v-bind='{...{"src":"https:\/\/api.arair.ir\/storage\/asset\/ \u0634\u0642\u06cc\u0642\u0647 2 (2).jpg","alt":"mix it web"},...{}}' :style='""' class="mx-auto col-12" ></m-img></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mH4,mImg },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
